// from https://gist.github.com/codeguy/6684588 (max10rogerio's versh)
export const slugify = (...args: (string | number)[]): string => {
  const value = args.join(" ")

  return value
    .normalize("NFD") // split an accented letter in the base letter and the acent
    .replace(/[\u0300-\u036f]/g, "") // remove all previously split accents
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9 ]/g, "") // remove all chars not letters, numbers and spaces (to be replaced)
    .replace(/\s+/g, "-"); // separator
}

// chatgpt 🤷‍♀️
export const unslugify = (slug: string) =>
  slug
    // Split the string on each underscore or hyphen
    .split(/[-_]/)
    // Capitalize the first letter of each word and join them with a space
    .map((word, index) => (index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(" ")
export default unslugify
